<template>
<div>
  <el-drawer
    :visible.sync="show"
    direction="rtl"
    size="50%"
    :withHeader="false"
    :close-on-press-escape="false"
    :before-close="close">
    <div class="mt-10"></div>
      <el-divider content-position="left">基本信息</el-divider>
      <el-form :model="formData" label-width="120px" size="small">
        <el-form-item label="">
          <div class="flex middle">
            <div style=""><Avatar :src="formData.headImgUrl" :name="formData.fullName"></Avatar></div>

            <div style="width:50px;text-align:center"><i class="el-icon-d-arrow-right" /></div>

            <!-- slowLifeUserId isShowBindBox -->
            <div v-if="!formData.slowLifeUserId">
              <el-button type="primary" @click="doShowLinkBox">绑定喜悦汇名人</el-button>
            </div>
            <template v-else>
              <div><Avatar :src="formData.customHeadImgUrl" :name="formData.memo"></Avatar></div>
              <div style="width:10px;text-align:center"></div>
              <div><el-button type="primary" @click="doShowLinkBoxAndEdit" size="mini" class="mt-10" icon="el-icon-arrow-left">更换绑定喜悦汇名人</el-button></div>
            </template>
            <!-- <div class="uploadBox" v-if="!formData.customHeadImgUrl">
              <input type="file" name="file" accept="image/*" ref="upload" @change="doUpload">
              <div class="icon"><i class="el-icon-user-solid" /></div>
              <div class="text">点击上传</div>
            </div>
            <template v-else>
              <div style="height:60px;overflow:hidden"><Avatar :src="formData.customHeadImgUrl">
                <div class="avatar-uploader">
                  <input type="file" name="file" accept="image/*" ref="upload"  @change="doUpload">
                  <div class="uploadBoxInAvatar">
                    <div class="icon"><i class="el-icon-camera" /></div>
                  </div>
                </div>  
              </Avatar></div>
            </template> -->
          </div>
          
        </el-form-item>
        <el-form-item label="用户原名">
          {{formData.fullName}}
        </el-form-item>
        <!-- <el-form-item label="用户别名">
          <el-input v-model="formData.memo" autocomplete="off" style="width:200px" :readonly="!!formData.slowLifeUserId" @keyup.enter.native="doMemoSubmit"></el-input>
          <el-button type="primary" @click="doMemoSubmit" :loading="isMemoLoading" class="ml-10" v-if="!formData.slowLifeUserId">保 存</el-button>
        </el-form-item> -->
        <el-form-item label="用户标签">
          <div v-if="formData.tags && formData.tags.length" class="mb-10">
            <el-tag
              v-for="(tag,index) in formData.tags"
              :key="tag.tagId"
              closable
              size="mini"
              @close="doTagDelete(tag,index)">
              {{tag.tagName}}
            </el-tag>
          </div>
          <div>
            <el-input 
              @keyup.enter.native="doTagNameSubmit"
              v-model="formData.tagName" 
              autocomplete="off" 
              style="width:140px"
              :readonly="isTagNameLoading"
            ></el-input>
            <el-button type="primary" @click="doTagNameSubmit" :loading="isTagNameLoading" class="ml-10">新 增</el-button>

          </div>
          
        </el-form-item>

        <div class="mt-20"></div>
        <el-divider content-position="left">自动发布配置</el-divider>


        <el-form-item label="自动发布">
          <el-select v-model="formData.extension.se.syncType" placeholder="请选择">
            <el-option label="关闭" value="NONE"></el-option>
            <el-option label="用户自定义时段" value="USER"></el-option>
            <el-option label="跟随主标签" value="TAG"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户自定义时段" v-if="formData.extension.se.syncType == 'USER'">
          <el-time-select
            placeholder="起始时间"
            style="width:120px;"
            v-model="formData.extension.se.payload.startAt"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '23:59'
            }">
          </el-time-select>
          - 
          <el-time-select
            placeholder="结束时间"
            style="width:120px;"
            v-model="formData.extension.se.payload.endAt"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '23:59',
              minTime: formData.extension.se.payload.startAt
            }">
          </el-time-select>
        </el-form-item>
        <el-form-item label="跟随主标签" v-if="formData.extension.se.syncType == 'TAG'">
          <el-select v-model="formData.extension.se.tagId" placeholder="请选择主标签">
            <el-option label="请选择" :value="0"></el-option>
            <el-option v-for="(tag) in formData.tags"
              :key="tag.tagId" :label="tag.tagName" :value="tag.tagId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" @click="doSyncSubmit" :loading="isSyncLoading">保 存</el-button>
        </el-form-item>

                


      </el-form>
      <div class="drawer-footer ta-r pd-10-20">
        <el-button @click="close" v-if="isShowSetLater">跳过,稍候再设</el-button>
        <!-- <el-button type="primary" @click="doSubmit">保 存</el-button> -->
      </div>

  </el-drawer>
  <UserBind :data.sync="formData" :show.sync="isShowBindBox" />

</div>

</template>

<script>
import UserBind from '@/components/UserBind';
export default {
  name: 'UserEdit',
  components: {
    UserBind
  },
  props: {
    data: Object,
    show: Boolean,
    isShowSetLater: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      formData:{
        extension:{
          se:{
            payload:{
              endAt:"",startAt:""
            },
            syncType:"NONE",
            tagId:0
          }
        },
      },
      linkData:{
        slowLifeUserId:"",
        customHeadImgUrl:"",
        memo:"",
      },
      linkData2:{
        slowLifeUserId:"",
        customHeadImgUrl:"",
        memo:"",
        city:"",
        field:""
      },
      isTagLoading:false,
      tagList:[],
      syncUserList:[],
      isMemoLoading:false,
      isTagNameLoading:false,
      isSyncLoading:false,
      isShowBindBox:false,
      lineType:"1"
    }
  },
  watch: {
    data(newData){
      var data = this.$root.copy({
        tags:[],tagName:"",memo:"",
        extension:{
          se:{
            syncType:"NONE",
          }
        },
        customHeadImgUrl:"",
        ...newData
      });
      console.log('data',data);
      

      if(!data.extension){
        data.extension = {};
      }
      if(!data.extension.se){
        data.extension.se = {
          payload:{
            endAt:"",startAt:""
          },
          syncType:"NONE",
          tagId:0
        }
      }
      if(!data.extension.se.payload || !data.extension.se.payload.endAt){
        data.extension.se.payload = {
          endAt:"",startAt:""
        };
      }
      if(!data.extension.se.tagId){
        data.extension.se.tagId = 0;
      }

      this.$set(this,'formData',data);
      console.log('this.formData',this.formData);
      // extension.se.payload.endAt.startAt
      // extension.se.syncType
      // extension.se.tagId
      // this.formData.customHeadImgUrl = newData.headImgUrl;
    }
  },
  
  methods:{
    doShowLinkBox(){
      this.isShowBindBox = true;
    },
    doShowLinkBoxAndEdit(){
      this.doShowLinkBox();
    },
    doTagDelete(tag,index){
      this.request.delete(`/api/v1/users/${this.formData.userId}/tag/${tag.tagId}`);
      this.formData.tags.splice(index,1);
    },
    async doSearchTag(query){
      if (query !== '') {
        this.isTagLoading = true;
        this.tagList = await this.request.get(`/api/v1/tags?page=1&size=20&tagName=${query}`).then( async res=>{
          this.isTagLoading = false;
          if(!res)return [];
          else return res.results || [];
        });
      } else {
        this.tagList = [];
      }
    },
    async doSelectTag(){
      
    },

    close(){
      this.$emit('update:show',false);
    },
    async doMemoSubmit(){
      if(!this.formData.memo){
        this.$message.warning("用户别名不能为空");
        return ;
      }
      this.isMemoLoading = true;
      this.request.post(`/api/v1/users/${this.formData.userId}/remark`,{memo:this.formData.memo}).then(res=>{
        this.isMemoLoading = false;
        this.$message.success("用户别名保存成功");
        return !!res;
      }).catch(err=>{
        console.log(err);
        this.isMemoLoading = false;
      });
      
    },

    async checkHasTagName(tagName){
      return await this.request.get(`/api/v1/tags?page=1&size=20&tagName=${tagName}`).then( async res=>{
        if(!res || !res.total){return false;}
        if(res.results && res.results.length){
          console.log(res.results);
          var target = res.results.find(t=>t.tagName == tagName);
          if(target && target.tagId){
            return target;
          } else {
            return false;
          }
        }
      });
    },

    async doAddUserTag(tagId){
      this.isTagNameLoading = true;
      return await this.request.post(`/api/v1/users/${this.formData.userId}/tag`,{tagId}).then(res=>{
        this.isTagNameLoading = false; 
        this.$message.success("标签添加成功");
        return res;
      });
    },
    async doCreateTag(tagName){
      this.isTagNameLoading = true;
      return await this.request.post(`/api/v1/tags`,{tagName}).then(async res=>{
        this.isTagNameLoading = false;
        return res;
      })
    },
    async doTagNameSubmit(){
      var tagName = this.formData.tagName.replace(/(^\s*)|(\s*$)/g, "");

      if(!tagName){
        this.$message.warning("标签不能为空");
        return ;
      }

      var target = this.formData.tags.find(t=>t.tagName === tagName);
      if(target){
        this.$message.warning("该用户已设该标签");
        return ;
      }

      var tag = await this.checkHasTagName(tagName);
      if(!tag){
        tag = await this.doCreateTag(tagName);
      }
      if(tag){
        await this.doAddUserTag(tag.tagId);
      }
      this.formData.tags.push(tag);
      this.formData.tagName = '';
      
    },

    async doSyncSubmit(){

      if(this.formData.extension.se.syncType == 'USER' && (!this.formData.extension.se.payload.startAt || !this.formData.extension.se.payload.endAt )){
        this.$message.warning("开始或结束时间不能为空"); return ;
      } else if(this.formData.extension.se.syncType == 'TAG' && !this.formData.extension.se.tagId){
        this.$message.warning("主标签不能为空"); return ;
      } else if(this.formData.extension.se.syncType == 'TAG'){
        var temp = this.formData.tags.find(t=>{
          if(t.extension && t.extension.se && t.extension.se.payload && t.extension.se.payload.startAt){
            return t;
          } else return false;
        });
        if(!temp){
          this.$message.warning("主标签未设置同步时间"); return ;
        }
        
      }
      this.isSyncLoading = true;

      var extension = this.$root.copy(this.formData.extension);
      if(extension.se.syncType == 'NONE'){
        if(typeof extension.se.payload != 'undefined'){
          delete extension.se.payload;
        }
        if(typeof extension.se.tagId != 'undefined'){
          delete extension.se.tagId;
        }
      }else if(extension.se.syncType == 'USER'){
        if(typeof extension.se.tagId != 'undefined'){
          delete extension.se.tagId;
        }
      }else if(extension.se.syncType == 'TAG'){
        if(typeof extension.se.payload != 'undefined'){
          delete extension.se.payload;
        }
      }

      this.doUserSave({extension},this.close);


    },
    async doUserSave(params,callback=()=>{}){
      return await this.request.put(`/api/v1/users/${this.formData.userId}`,params).then(async res=>{
        this.isSyncLoading = false;
        this.$message.success("保存成功");
        callback();
        return res;
      });
    }
  },
}
</script>

<style scoped lang="less">


</style>
